import React, {useState, useEffect, Component} from 'react'
import {Link} from 'react-router-dom'
import {Button, Dialog} from '@material-ui/core';
import ProductsForm from './ProductsForm'
import {SortableContainer, SortableElement,SortableHandle, arrayMove} from 'react-sortable-hoc';
import cloudinary from 'cloudinary-core'
import db from '../Firebase'
import _ from 'underscore'
import ProductInlineForm from './ProductInlineForm'
import SubMenuInlineForm from './SubMenuInlineForm'
import Dropzone from 'react-dropzone'
import request from 'superagent'
import './index.css'
import Photo from '../Photo'
import OtherPhotosDisplay from './OtherPhotosDisplay'
import GSCProductImageDropzone from '../Photos/GSCProductImageDropzone'
import {get} from 'lodash'
import {debounce} from 'lodash'
import AiImageEditorContainer from '../components/AiImageEditor'


var cl = cloudinary.Cloudinary.new({cloud_name: 'dgps1radv', secure: true});

function Products (props) {
  const [query, setQuery] = useState('')
  const {shop} = props

  console.log('query', query)

  const onSubMenuSortEnd = ({oldIndex, newIndex, collection}) => {
    console.log(oldIndex, newIndex)
    let subMenusOrderIndex = props.shop.subMenus.map(doc => doc.id)
    let newSubMenusOrderIndex = arrayMove(subMenusOrderIndex, oldIndex, newIndex)
    props.shop.ref.update({
      subMenusOrderIndex: newSubMenusOrderIndex
    })
  }
  let results = []
  if (query.length > 1) {
    shop.subMenus.forEach((submenu, index) => {
      submenu.products.forEach((product, index) => {
      
        const name = get(product.data(), 'name.en', '').toLowerCase()
        // console.log('found,', name)
        if (name && name.indexOf(query) !== -1) {
          // console.log('found,',product.id)
          results.push({product})
        }
      })
    })
  }
 

    return(
      <div className="p-4 space-y-4">

        <div className="mb-6">
          <div className="mb-4">
            <input 
              type="text" 
              value={query} 
              onChange={(e)=> {setQuery(e.target.value)}} 
              className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              placeholder="Search products..."
            />
          </div>
          <div className="space-y-2">
            {results.map(({product})=> {
  
              return(
                <div className="flex flex-wrap items-center gap-2 p-3 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition" key={product.id}>
                <GSCProductImageDropzone
                    product={product}
                  />
                  <AiImageEditorContainer product={product} />
                  <ProductInlineForm
                    product={product} />
                </div>
              )
            })}
          </div>
        </div>


        <Button variant="contained"
                color="primary"
                onClick={() => {
                  let subMenusOrderIndex = props.shop.subMenus.map(doc => doc.id)
                  props.shop.ref.parent.add({
                    draft: true,
                    type: "subMenu",
                    shopId: props.shop.get('shopId'),
                    orderIndex: []
                  }).then((docRef) => {
                    if (!docRef.id) { throw new Error('no id') }
                    let newSubMenusOrderIndex = [...subMenusOrderIndex, docRef.id]
                    props.shop.ref.update({
                      subMenusOrderIndex: newSubMenusOrderIndex
                    })
                  })
                }}
                >
                New Category to Bottom</Button>

        <Button variant="contained"
                color="secondary"
                onClick={async () => {
                  // Step 1: Get tag from user
                  const searchTag = prompt("Enter the tag to search for:");
                  if (!searchTag) { return; }

                  // Step 2: Get destination shopId
                  const newShopId = prompt("Enter the destination restaurant's shop ID:");
                  if (!newShopId) { return; }

                  try {
                    // Step 3: Validate that the shopId exists
                    const shopQuery = await db.collection('all')
                      .where('type', '==', 'shop')
                      .where('shopId', '==', newShopId)
                      .get();
                    
                    if (shopQuery.empty) {
                      alert(`Error: shopId "${newShopId}" doesn't exist`);
                      return;
                    }

                    // Step 4: Find all categories with matching tag
                    const matchingCategories = shop.subMenus.filter(submenu => {
                      const tag = submenu.get('tag') || '';
                      return tag.includes(searchTag);
                    });

                    if (matchingCategories.length === 0) {
                      alert(`No categories found with tag containing "${searchTag}"`);
                      return;
                    }

                    // Step 5: Copy each category and its products
                    const newCategoryIds = [];
                    
                    for (const submenu of matchingCategories) {
                      // Create the new category
                      const newCategoryData = {
                        ...submenu.data(),
                        shopId: newShopId,
                        orderIndex: []
                      };
                      const newCategoryRef = await db.collection('all').add(newCategoryData);
                      const newCategoryId = newCategoryRef.id;
                      newCategoryIds.push(newCategoryId);

                      // Copy all products with new shopId and subMenuId
                      const newProductIds = [];
                      for (const product of (submenu.products || [])) {
                        const newProductData = {
                          ...product.data(),
                          shopId: newShopId,
                          subMenuId: newCategoryId
                        };
                        const newProductRef = await db.collection('all').add(newProductData);
                        newProductIds.push(newProductRef.id);
                      }

                      // Update the category's orderIndex with new product IDs
                      await newCategoryRef.update({ orderIndex: newProductIds });
                    }

                    // Step 6: Update the shop's subMenusOrderIndex to include all new categories
                    const shopDoc = shopQuery.docs[0];
                    const currentSubMenusOrderIndex = shopDoc.data().subMenusOrderIndex || [];
                    await shopDoc.ref.update({
                      subMenusOrderIndex: [...currentSubMenusOrderIndex, ...newCategoryIds]
                    });

                  } catch (error) {
                    console.error('Error copying categories by tag:', error);
                    alert('Error copying categories: ' + error.message);
                  }
                }}
                >
                Copy Categories by Tag to New Restaurant</Button>

        <SortableSubmenus
          useDragHandle
          onSortEnd={onSubMenuSortEnd}
          subMenus={shop.subMenus} />
        <ul>

        </ul>
      </div>
    )
}
const SortableProduct = SortableElement(({isSelected, onTouchStart, product, rowNumber}) => {
  const onClickCopyToOtherShop = () => {
    // get shop id from user
    const newShopId = prompt("Enter the new shop ID:")
    if (!newShopId) { return }
    product.ref.parent.add({
      ...product.data(),
      shopId: newShopId,
      subMenuId: "4WRsPRs46upyrLJHstNi"
    })
  }
  
  return (
    <div 
      className={`flex flex-wrap items-center gap-2 p-2 border-b border-gray-100 hover:bg-gray-50 transition ${isSelected ? 'bg-blue-100' : ''}`} 
      onClick={onTouchStart}
    >
      <DragHandle />
      <GSCProductImageDropzone product={product} />
      <OtherPhotosDisplay product={product} />
      <AiImageEditorContainer product={product} />

      <ProductInlineForm rowNumber={rowNumber} product={product} />

      <div className="flex gap-1 ml-auto">
        <button 
          onClick={() => console.log(product.data())}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition"
        >
          ?
        </button>
        <button 
          onClick={() => product.ref.parent.add(product.data())}
          className="px-2 py-1 text-xs bg-blue-100 hover:bg-blue-200 text-blue-700 rounded transition"
        >
          dup
        </button>
        <button 
          onClick={onClickCopyToOtherShop}
          className="px-2 py-1 text-xs bg-green-100 hover:bg-green-200 text-green-700 rounded transition"
        >
          COPY
        </button>
        <button 
          onClick={() => {
            if(window.confirm(`delete ${product.get('name.en')}?`)) {
              product.ref.delete().then().catch(console.log)
            }
          }}
          className="px-2 py-1 text-xs bg-red-100 hover:bg-red-200 text-red-700 rounded transition"
        >
          🚮
        </button>
      </div>
    </div>
  )
});
const SortableProducts = SortableContainer(({products}) => {
  const [selectedProduct, setSelectedProduct] = useState(null)
  function handleTouchProduct (id) {
    console.log('touched', id)
    setSelectedProduct(id)
  }
  return (
    <div className="flex flex-col bg-white rounded-lg overflow-hidden">
      {products.map((product, index) => {
        const isSelected = (selectedProduct === product.id) 
        return(
          <SortableProduct 
            isSelected={isSelected}
            onTouchStart={handleTouchProduct.bind(this, product.id)}
            key={product.id} 
            rowNumber={index} 
            index={index} 
            product={product} 
          />
        )
      })}
    </div>
  );
});

const SortableSubMenu = SortableElement(({submenu}) => {
  return(<SubMenuBlock submenu={submenu}></SubMenuBlock>)
})
class SubMenuBlock extends Component {
  state = {
    showProducts: false,
    selectedProductId: false,
  }
  toggleProducts = () => {
    this.setState({showProducts: !this.state.showProducts})
  }
  render () {
    const submenu = this.props.submenu
    const {showProducts} = this.state
    return (
      <div className="border border-gray-300 rounded-lg mb-3 bg-white shadow-sm overflow-hidden">
        <header className="flex items-center gap-2 p-2 bg-gray-50 border-b border-gray-200">
          <DragHandle />
          <button 
            onClick={this.toggleProducts}
            className="flex items-center gap-1 px-3 py-1 text-sm font-medium bg-white border border-gray-300 rounded hover:bg-gray-100 transition"
          >
            <span className="w-4">{showProducts ? "▼" : "▶︎"}</span>
            <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-semibold">
              {submenu.products.length}
            </span>
          </button>
          <SubMenuInlineForm subMenu={submenu} />
          <Button
            onClick={() => {
              submenu.ref.parent.add({
                draft: true,
                type: "product",
                shopId: submenu.get('shopId'),
                subMenuId: submenu.id
              })
            }}
            color="primary"
          >
            New Dish
          </Button>
        </header>
        {false &&
          <div className="flex gap-2 p-2 bg-yellow-50 border-b border-yellow-200">
            <button 
              className="px-3 py-1 text-sm bg-green-100 hover:bg-green-200 text-green-700 rounded transition"
              onClick={() => {
                const updates = submenu.products.map((product) => {
                  const price = Number(product.get('price'))
                  if ((price > 0)) {
                    return product.ref.update({
                      price: price + 1
                    })
                  }
                })
                Promise.all(updates).then(() => {})
              }}
            >
              Add $1 to non zero and non text prices
            </button>
            <button 
              className="px-3 py-1 text-sm bg-red-100 hover:bg-red-200 text-red-700 rounded transition"
              onClick={() => {
                const updates = submenu.products.map((product) => {
                  const price = Number(product.get('price'))
                  if ((price > 1)) {
                    return product.ref.update({
                      price: price - 1
                    })
                  }
                })
                Promise.all(updates).then(() => {})
              }}
            >
              Subtract $1
            </button>
          </div>
        }
        {showProducts && (
          <div className="p-2">
            <SortableProducts 
              useDragHandle 
              axis="xy" 
              onSortEnd={({oldIndex, newIndex}) => {
                submenu.ref.update({ orderIndex: arrayMove(submenu.products.map(p=>p.id), oldIndex, newIndex) })
              }} 
              products={submenu.products} 
            />
          </div>
        )}
      </div>
    )
  }
}

const SortableSubmenus = SortableContainer(({subMenus}) => {
  return (
    <div className="space-y-3">
      {subMenus.map((submenu, index) => (
        <SortableSubMenu key={submenu.id} index={index} submenu={submenu} />
      ))}
    </div>
  );
});

const DragHandle = SortableHandle(() => (
  <span
    className="block w-5 h-12 bg-gradient-to-b from-gray-600 to-gray-800 rounded cursor-grab hover:from-gray-500 hover:to-gray-700 transition-colors flex-shrink-0"
    title="Drag to reorder"
  >
    &nbsp;
  </span>
))
export default Products
